import React from "react";

export const exportIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 7L20 5C20 4.46957 19.7893 3.96086 19.4142 3.58579C19.0391 3.21071 18.5304 3 18 3L6 3C5.46957 3 4.96086 3.21072 4.58579 3.58579C4.21071 3.96086 4 4.46957 4 5L4 7M17 13L12 8M12 8L7 13M12 8L12 20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
